<container class={className}>
  <yield />

  <script>
   import style from './container.scss';
   this.className = style.container + ' ' + (this.opts.class || '');
  </script>
</container>
